<script>
	import {
		CONSENT_COOKIE_UPDATED_EVENT,
		changeConsentForCookieCategory,
		getConsentForCookieCategory,
		isTcfEnabled,
	} from "../helpers/cookie-control";

	import reframe from "reframe.js";

	export default {
		name: "cookie-consent",

		data: () => ({
			hasCookieConsent: false,
			civicLoaded: false,
			userCookieCategoryPreferences: [],
		}),

		props: {
			requiredCookieCategories: {
				type: Array,
				default: [],
			},
			showConsentUi: {
				type: Boolean,
				default: true,
			},
		},

		mounted() {
			this.mutationObserver();
			this.cookieChangeListener();

			this.civicLoaded = !!window.civicLoaded;

			this.hasCookieConsent = this.checkConsent();
		},

		methods: {
			/**
			 * Checks if the required cookie category(ies) have been accepted.
			 *
			 * @returns {boolean}
			 */
			checkConsent() {
				if (this.$props.requiredCookieCategories.length === 0) {
					return true;
				}

				let categories = [];

				for (let i = 0; i < this.$props.requiredCookieCategories.length; i++) {
					let category = this.$props.requiredCookieCategories[i];
					let hasConsent = getConsentForCookieCategory(category);

					categories.push({ category, hasConsent });
				}

				this.userCookieCategoryPreferences = categories;

				return categories.every((category) => category.hasConsent);
			},

			/**
			 * Updates the users consent preferences to allow the required categories.
			 */
			acceptRequiredCategories() {
				if (isTcfEnabled()) {
					CookieControl.acceptAll();
				} else {
					this.requiredCookieCategories.forEach((category) =>
						changeConsentForCookieCategory(category, true),
					);
				}
			},

			/**
			 * Builds a formatted string representing the names of the required cookie categories.
			 *
			 * @returns {string}
			 */
			requiredCategoryString() {
				if (isTcfEnabled()) {
					return "Accept all cookies";
				}

				let missingCategories = this.userCookieCategoryPreferences
					.filter((category) => !category.hasConsent)
					.map((category) => category.category);

				let categoryString;

				switch (missingCategories.length) {
					case 0:
						categoryString = "";
						break;
					case 1:
						categoryString = missingCategories.pop();
						break;
					case 2:
						categoryString = `${missingCategories[0]} and ${missingCategories[1]}`;
						break;
					default:
						let last = missingCategories.pop();
						categoryString = `${missingCategories.join(", ")} and ${last}`;
				}

				return ["Allow", categoryString, "cookies"]
					.filter((part) => !!part)
					.join(" ");
			},

			cookieChangeListener() {
				let self = this;

				/**
				 * We listen for changes to the consent cookie via an event listener.
				 *
				 * The CONSENT_COOKIE_UPDATED_EVENT is dispatched from within the CookieControl/Civics
				 * configuration script various "onAccept" methods.
				 */
				document.addEventListener(CONSENT_COOKIE_UPDATED_EVENT, function () {
					self.civicLoaded = window.civicLoaded;

					/**
					 * The cookies value isn't updated until after "onAccept" has run therefore we use setTimeout
					 * to read the cookie on the next event loop.
					 */
					setTimeout(() => (self.hasCookieConsent = self.checkConsent()));
				});
			},

			mutationObserver() {
				let observer = new MutationObserver(() => {
					reframe(
						'.c-embed:not([style*="--aspect-ratio"]) iframe[src*="youtu.be"]',
					);
					reframe(
						'.c-embed:not([style*="--aspect-ratio"]) iframe[src*="youtube.com"]',
					);
					reframe(
						'.c-embed:not([style*="--aspect-ratio"]) iframe[src*="vimeo.com"]',
					);
					observer.disconnect();
				});

				observer.observe(this.$el, {
					childList: true,
					subtree: true,
				});
			},
		},
	};
</script>
